"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiReportRefundResponseDto = void 0;
const types_1 = require("../../../billing-api-account/types");
const types_2 = require("../../../billing-api-charge/types");
const types_3 = require("../../../billing-api-contractor/types");
const types_4 = require("../../../billing-api-order/types");
const types_5 = require("../../../billing-api-payment/types");
const billing_core_refund_reason_enum_1 = require("../../../../billing-core/billing-core-refund/types/enums/billing-core-refund-reason.enum");
const billing_core_refund_status_enum_1 = require("../../../../billing-core/billing-core-refund/types/enums/billing-core-refund-status.enum");
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let BillingApiReportRefundResponseDto = class BillingApiReportRefundResponseDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "ID возврата"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportRefundResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Контрагент",
  type: () => types_3.BillingApiContractorResponseDto
}), (0, class_transformer_1.Expose)(), __metadata("design:type", types_3.BillingApiContractorResponseDto)], BillingApiReportRefundResponseDto.prototype, "contractor", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма в валюте оплаты",
  format: "decimal",
  example: "15.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportRefundResponseDto.prototype, "amount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Код валюты оплаты",
  example: "USD"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportRefundResponseDto.prototype, "currencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Статус возврата",
  enum: billing_core_refund_status_enum_1.BillingCoreRefundStatusEnum
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportRefundResponseDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Причина возврата",
  enum: billing_core_refund_reason_enum_1.BillingCoreRefundReasonEnum
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiReportRefundResponseDto.prototype, "reason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Опциональный комментарий",
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), __metadata("design:type", Object)], BillingApiReportRefundResponseDto.prototype, "comment", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Начисления за которые осуществлён возврат",
  type: () => types_2.BillingApiChargeResponseDto,
  isArray: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Array)], BillingApiReportRefundResponseDto.prototype, "charges", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сделка к которой принадлежит возврат",
  type: () => types_4.BillingApiOrderResponseDto
}), (0, class_transformer_1.Expose)(), __metadata("design:type", types_4.BillingApiOrderResponseDto)], BillingApiReportRefundResponseDto.prototype, "order", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Счёт на который осуществлён возврат",
  type: () => types_1.BillingApiAccountResponseDto
}), (0, class_transformer_1.Expose)(), __metadata("design:type", types_1.BillingApiAccountResponseDto)], BillingApiReportRefundResponseDto.prototype, "account", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Платёж для которого осуществлён возврат",
  type: () => types_5.BillingApiPaymentResponseDto
}), (0, class_transformer_1.Expose)(), __metadata("design:type", types_5.BillingApiPaymentResponseDto)], BillingApiReportRefundResponseDto.prototype, "payment", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Url плательщика у мерчант-провайдера (если есть)",
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), __metadata("design:type", Object)], BillingApiReportRefundResponseDto.prototype, "providerCustomerLink", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Url операции у мерчант-провайдера (если есть)",
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), __metadata("design:type", Object)], BillingApiReportRefundResponseDto.prototype, "providerOperationLink", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата и время операции",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Date)], BillingApiReportRefundResponseDto.prototype, "createdAt", void 0);
BillingApiReportRefundResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiReportRefundResponseDto);
exports.BillingApiReportRefundResponseDto = BillingApiReportRefundResponseDto;
